import { render, staticRenderFns } from "./SepaSettings.vue?vue&type=template&id=56a6b59c"
import script from "./SepaSettings.vue?vue&type=script&lang=ts"
export * from "./SepaSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports